import { http } from './request';
import type {
  Tenant,
  UpdateTenantRequest,
  Member,
  InviteMemberRequest,
  InvitationResponse,
  UpdateMemberRoleRequest,
  Role,
  Permission,
  Subscription,
  UsageStats,
} from '../types/tenant';
import type { ListData, PaginationParams } from '../types/api';

export const tenantApi = {
  // 获取当前租户信息
  getCurrentTenant: () =>
    http.get<Tenant>('/api/v1/tenant'),

  // 更新租户信息
  updateTenant: (data: UpdateTenantRequest) =>
    http.put<Tenant>('/api/v1/tenant', data),

  // 成员管理
  getMembers: (params?: PaginationParams) =>
    http.get<ListData<Member>>('/api/v1/tenant/members', params),

  inviteMember: (data: InviteMemberRequest) =>
    http.post<InvitationResponse>('/api/v1/tenant/members/invite', data),

  // 接受邀请
  acceptInvite: (inviteCode: string) =>
    http.post<{ message: string }>('/api/v1/tenant/members/accept-invite', { invite_code: inviteCode }),

  removeMember: (memberId: string) =>
    http.delete<void>(`/api/v1/tenant/members/${memberId}`),

  updateMemberRole: (memberId: string, data: UpdateMemberRoleRequest) =>
    http.put<{ message: string }>(`/api/v1/tenant/members/${memberId}/role`, data),

  // 角色权限
  getRoles: () =>
    http.get<Role[]>('/api/v1/tenant/roles'),

  getRolePermissions: (roleName: string) =>
    http.get<Permission[]>(`/api/v1/tenant/roles/${roleName}/permissions`),

  checkPermission: (permission: string) =>
    http.post<{ allowed: boolean }>('/api/v1/tenant/check-permission', { permission }),

  // 订阅管理
  getSubscription: () =>
    http.get<Subscription>('/api/v1/tenant/subscription'),

  // 用量统计
  getUsageStats: () =>
    http.get<UsageStats>('/api/v1/tenant/usage-stats'),
};

// 注意：团队管理、账单管理 API 后端暂未实现
